import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { HeaderTabs } from './shared';

export type AppointmentModuleFooterProps = {
    activeTab: HeaderTabs;
};

const AppointmentModuleFooter = ({ activeTab }: AppointmentModuleFooterProps) => {
    const { t } = useTranslation(['appointmentModuleDetails']);

    const formName = activeTab === HeaderTabs.MainDetails ? 'updateMainDetails' : 'updateEmailContent';

    return (
        <Button form={formName} htmlType="submit" type="primary">
            {t('appointmentModuleDetails:actions.update')}
        </Button>
    );
};

export default AppointmentModuleFooter;
